import Modal from "./Modal";
import Gallery from "./Gallery";
import ModalFixed from "./ModalFixed";
import Accordion from "./Accordion";

export function DistanciaNuevos() {
  const items = [
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/distancia/nuevos/portada.jpg",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/distancia/nuevos/paso1.jpg",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/distancia/nuevos/paso2.jpg",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/distancia/nuevos/paso3.jpg",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/distancia/nuevos/paso4.jpg",
    },
  ];

  return (
    <Modal
      title="Revisa el proceso de matrícula para estudiantes nuevos"
      content={
        <>
          <div className="width400">
            <Gallery gallery={items} width="400"></Gallery>
          </div>
        </>
      }
    ></Modal>
  );
}

export function DistanciaNuevosFixed() {
  const items = [
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/distancia/nuevos/portada.jpg",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/distancia/nuevos/paso1.jpg",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/distancia/nuevos/paso2.jpg",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/distancia/nuevos/paso3.jpg",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/distancia/nuevos/paso4.jpg",
    },
  ];

  return (
    <ModalFixed
      color="#9184ec"
      title="Proceso de matrícula"
      content={
        <>
          {" "}
          <div className="width400">
            <Gallery gallery={items} width="400"></Gallery>
          </div>
        </>
      }
    ></ModalFixed>
  );
}

export function DistanciaContinuos() {
  const items = [
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/distancia/continuos/portada.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/distancia/continuos/paso1.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/distancia/continuos/paso2.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/distancia/continuos/paso3.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/distancia/continuos/paso4.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/distancia/continuos/paso5.png",
    },
  ];

  return (
    <Modal
      title="Revisa el proceso de matrícula para estudiantes continuos"
      content={
        <>
          {" "}
          <div className="width400">
            <Gallery gallery={items} width="400"></Gallery>
          </div>
        </>
      }
    ></Modal>
  );
}

export function PresencialInscripcion() {
  const items = [
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/inscripcion/portada.jpg",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/inscripcion/paso1.jpg",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/inscripcion/paso2.jpg",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/inscripcion/paso3.png",
    },
  ];

  return (
    <Modal
      title="Revisa el proceso de inscripción👌"
      content={
        <>
          {" "}
          <div className="width400">
            <Gallery gallery={items} width="400"></Gallery>
          </div>
        </>
      }
    ></Modal>
  );
}

export function PresencialInscripcionFixed() {
  const items = [
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/inscripcion/portada.jpg",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/inscripcion/paso1.jpg",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/inscripcion/paso2.jpg",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/inscripcion/paso3.png",
    },
  ];

  return (
    <ModalFixed
      color="#699d79"
      id="inscripcionpresencial"
      title="Revisa el proceso de inscripción👌"
      content={
        <>
          {" "}
          <div className="width400">
            <Gallery gallery={items} width="400"></Gallery>
          </div>
        </>
      }
    ></ModalFixed>
  );
}

export function PresencialNuevos() {
  const items = [
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/nuevos/portada.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/nuevos/paso1.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/nuevos/paso2.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/nuevos/paso3.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/nuevos/paso4.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/nuevos/paso5.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/nuevos/paso6.png",
    },
  ];

  return (
    <Modal
      title="Revisa el proceso de matrícula para estudiantes nuevos 📱"
      content={
        <>
          {" "}
          <div className="width400">
            <Gallery gallery={items} width="400"></Gallery>
          </div>
        </>
      }
    ></Modal>
  );
}

export function PresencialContinuos() {
  const items = [
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/continuos/portada.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/continuos/paso1.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/continuos/paso2.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/continuos/paso3.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/continuos/paso4.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/presencial/continuos/paso5.png",
    },
  ];

  return (
    <Modal
      title="Revisa el proceso de matrícula para estudiantes continuos 📱"
      content={
        <>
          {" "}
          <div className="width400">
            <Gallery gallery={items} width="400"></Gallery>
          </div>
        </>
      }
    ></Modal>
  );
}

export function TecnologiasContinuos() {
  const items = [
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/tecnologias/continuos/portada.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/tecnologias/continuos/paso1.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/tecnologias/continuos/paso2.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/tecnologias/continuos/paso3.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/tecnologias/continuos/paso4.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/tecnologias/continuos/paso5.png",
    },
  ];

  return (
    <Modal
      title="Revisa el proceso de matrícula para estudiantes continuos 📱"
      content={
        <>
          {" "}
          <div className="width400">
            <Gallery gallery={items} width="400"></Gallery>
          </div>
        </>
      }
    ></Modal>
  );
}

export function PosgradoPostulacion() {
  const items = [
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/posgrados/postulacion2/portada.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/posgrados/postulacion2/paso1.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/posgrados/postulacion2/paso2.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/posgrados/postulacion2/paso3.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/posgrados/postulacion2/paso4.png",
    },
  ];

  return (
    <Modal
      title="Revisa el proceso de postulación 👌"
      content={
        <>
          <div className="width400">
            <Gallery gallery={items} width="400"></Gallery>
          </div>
        </>
      }
    ></Modal>
  );
}

export function NormativaPosgrados() {
  return (
    <>
      <div className="margin1em">
        <Modal
          title="Proceso de admisión "
          content={
            <div  className="lightbluebg fontsize11 padding2">
              <ul>
                <li>
                  <strong>Verificación de requisitos habilitantes</strong>
                  <ul>
                    <li>
                      Se revisa el cumplimiento del requisito obligatorio de
                      título de tercer nivel de grado en el campo de
                      conocimiento.
                    </li>
                  </ul>
                </li>

                <li>
                  <strong>Evaluación académica del postulante</strong>
                  <ul>
                    <li>
                      Se realiza mediante una entrevista de admisión
                      estandarizada, evaluada con una rúbrica institucional
                      (sobre 6 puntos), que valora:
                    </li>
                    <ul>
                      <li>Motivación y alineación con el programa.</li>
                      <li>
                        Capacidad de organización del tiempo y autorregulación
                        académica.
                      </li>
                      <li>
                        Pensamiento crítico frente a retos académicos y
                        profesionales.
                      </li>
                    </ul>
                    <li>
                      A través de la entrevista se identifican, de manera
                      cualitativa, indicios de comprensión lectora, razonamiento
                      lógico y disposición para el aprendizaje autónomo, a
                      partir de la coherencia, claridad y profundidad de sus
                      respuestas.
                    </li>
                  </ul>
                </li>

                <li>
                  <strong>Evaluación de la hoja de vida</strong>
                  <ul>
                    <li>
                      Experiencia profesional afín al programa (hasta 2 puntos).
                    </li>
                    <li>
                      Capacitaciones, méritos académicos, publicaciones y
                      reconocimientos (hasta 2 puntos).
                    </li>
                  </ul>
                </li>

                <li>
                  <strong>Aplicación de acciones afirmativas</strong>
                  <ul>
                    <li>
                      En concordancia con la normativa vigente y las políticas
                      institucionales, la universidad aplicará acciones
                      afirmativas en el proceso de admisión, orientadas a
                      garantizar la igualdad de oportunidades, la inclusión y la
                      no discriminación de grupos de atención prioritaria, sin
                      que ello implique la disminución de los estándares
                      académicos del programa.
                    </li>
                  </ul>
                </li>

                <li>
                  <strong>Decisión de admisión</strong>
                  <ul>
                    <li>
                      Con base en los resultados de la entrevista y la
                      evaluación de la hoja de vida, el comité define la
                      admisión del postulante y las acciones de orientación y
                      acompañamiento académico inicial.
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          }
        >
          {" "}
        </Modal>
      </div>
      <div className="flex col3 ">
        <div>
          <p>
            {" "}
            <a
              className="button1"
              href="http://utpl.edu.ec/documentos/rubrica_posgrados.pdf"
            >
              Conoce la rúbrica de evaluación de admisión
            </a>
          </p>
        </div>
        <div>
          <p>
            {" "}
            <a
              className="button1"
              href="http://utpl.edu.ec/documentos/instructivo_admision.pdf"
            >
              Revisa nuestro instructivo de admisión
            </a>
          </p>
        </div>
        <div>
          <p>
            {" "}
            <a
              className="button1"
              href="http://utpl.edu.ec/documentos/politica_accion.pdf"
            >
              Revisa nuestra política de acción afirmativa
            </a>
          </p>
        </div>
      </div>
    </>
  );
}

export function PosgradosHome() {
  const items = [
    {
      title: "utpl",
      url: "https://www.utpl.edu.ec/maestrias/sites/default/files/posgrados1.png",
    },
    {
      title: "utpl",
      url: "https://www.utpl.edu.ec/maestrias/sites/default/files/posgrados2.png",
    },
    {
      title: "utpl",
      url: "https://www.utpl.edu.ec/maestrias/sites/default/files/posgrados3.png",
    },
  ];

  return (
    <>
      <Modal
        title="📹 Proceso de postulación y matrícula"
        content={
          <>
            <div>
              <iframe
                width="100%"
                height="449"
                src="https://www.youtube.com/embed/rL-8vTAn8P0"
                title="Posgrados UTPL | Admisión y matrícula paso a paso"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </>
        }
      ></Modal>
      <Modal
        title="✏️ Proceso de postulación y matricula"
        content={
          <>
            {" "}
            <div className="width400">
              <Gallery gallery={items} width="400"></Gallery>
            </div>
          </>
        }
      ></Modal>
    </>
  );
}

export function PosgradoPostulacionFixed() {
  const items = [
    {
      title: "utpl",
      url: "https://www.utpl.edu.ec/maestrias/sites/default/files/posgrados1.png",
    },
    {
      title: "utpl",
      url: "https://www.utpl.edu.ec/maestrias/sites/default/files/posgrados2.png",
    },
    {
      title: "utpl",
      url: "https://www.utpl.edu.ec/maestrias/sites/default/files/posgrados3.png",
    },
  ];

  return (
    <>
      <div className="requisitos-posgrados">
        <h3>Últimos días | Matrículas hasta el 1 de abril</h3>
          <p>
          <b> Inicio de clases:</b> abril 2026{" "}
        </p>
        <br></br>
        <Modal
          title="📹 Proceso de postulación y matrícula"
          content={
            <>
              <div>
                <iframe
                  width="100%"
                  height="449"
                  src="https://www.youtube.com/embed/rL-8vTAn8P0"
                  title="Posgrados UTPL | Admisión y matrícula paso a paso"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </div>
            </>
          }
        ></Modal>
        <Modal
          title="✏️ Proceso de postulación y matricula"
          content={
            <>
              {" "}
              <div className="width400">
                <Gallery gallery={items} width="400"></Gallery>
              </div>
            </>
          }
        ></Modal>{" "}
      </div>
      <br></br>
    </>
  );
}

export function PosgradosSalud() {
  const items = [
    {
      title: "utpl",
      url: "https://www.utpl.edu.ec/maestrias/sites/default/files/posgrados-especialidad-1.png",
    },
    {
      title: "utpl",
      url: "https://www.utpl.edu.ec/maestrias/sites/default/files/posgrados-especialidad-2.png",
    },
    {
      title: "utpl",
      url: "https://www.utpl.edu.ec/maestrias/sites/default/files/paso3-4.png",
    },
    {
      title: "utpl",
      url: "https://www.utpl.edu.ec/maestrias/sites/default/files/posgrados-especialidad-4.png",
    },
  ];

  return (
    <>
      <Modal
        title="✏️ Proceso de postulación y matricula"
        content={
          <>
            {" "}
            <div className="width400">
              <Gallery gallery={items} width="400"></Gallery>
            </div>
          </>
        }
      ></Modal>
      <br></br>
    </>
  );
}

export function PosgradoNuevos() {
  const items = [
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/posgrados/matricula/portada.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/posgrados/matricula/paso1.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/posgrados/matricula/paso2.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/posgrados/matricula/paso3.png",
    },
    {
      title: "utpl",
      url: "https://utpl.edu.ec/recursos/pasos/posgrados/matricula/paso4.png",
    },
  ];

  return (
    <Modal
      title="Revisa el proceso de matrícula para estudiantes nuevos 📱"
      content={
        <>
          {" "}
          <div className="width400">
            <Gallery gallery={items} width="400"></Gallery>
          </div>
        </>
      }
    ></Modal>
  );
}
